import { defineComponent, ref } from 'vue'
import useBreakpoints from '@/composables/use-breakpoints'

export default defineComponent({
    setup() {
        const breakpoints = useBreakpoints()
        const isSm = breakpoints.greaterOrEqual('sm')
        const open = ref(false)

        return {
            open,
            isSm
        }
    }
})